import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedFloor, setSelectedRoom } from "@/redux/slice/table-slice/table-slice";
import QuickTableModal from "./QuickTableModal";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function HeaderBar({setIsItemEdit}) {
  const dispatch = useDispatch();

  const { floors, rooms, selectedFloor, selectedRoom } = useSelector(
    (state) => state.table.table
  );

  const handleFloorSelect = (e) => {
    const id = e.target.value;
    const found = floors.find((f) => String(f.id) === String(id));
    dispatch(setSelectedFloor(found)); // send full object
  };

  const handleRoomSelect = (e) => {
    const id = e.target.value;
    const found = rooms.find((r) => String(r.id) === String(id));
    dispatch(setSelectedRoom(found)); // send full object
  };

  const [isAddNewBookingTableModalOpen, setIsAddNewBookingTableModalOpen] = useState(false);
  const closeAddNewBookingTableModal = () => {
    setIsAddNewBookingTableModalOpen(false);
  };

  return (
    <>
      <div className="flex items-center justify-between  mb-3 tab-max:mb-6 ">
        <div className="flex gap-11 items-center">
          <div>
            <h1 className=" tab-max:text-xl font-medium">Table</h1>
            <p className=" text-xs tab-max:text-sm font-normal flex gap-1 items-center">
              <Link to={"/"}>Home</Link>
              <span className="text-[#ffbb00]">{">"}</span>
              <span className="cursor-pointer text-[#ffbb00]">Table</span>
            </p>
          </div>

          <div className="flex space-x-4">
            {/* Floor Dropdown */}
            <div className="relative inline-flex items-center">
              <select
                value={selectedFloor?.id || ""}
                onChange={handleFloorSelect}
                className="
                  appearance-none
                  bg-color3
                  text-white
                  text-base
                  font-light
                  px-4 py-1 tab-max:py-2
                  pr-10
                  rounded-md
                  border border-gray-700
                  focus:outline-none
                  focus:ring-1 focus:ring-gray-500
                "
              >
                {floors
                  ?.filter(item => item.status !== "inactive")
                  ?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                ))}
              </select>

              {/* Dropdown Icon */}
              <ChevronDown
                size={16}
                className="absolute right-3 text-gray-400 pointer-events-none"
              />
            </div>

            <div className="relative inline-flex items-center">
              <select
                value={selectedRoom?.id || ""}
                onChange={handleRoomSelect}
                className="
                  appearance-none
                  bg-color3
                  text-white
                  text-base
                  font-light
                  px-4 py-1 tab-max:py-2
                  pr-10
                  rounded-md
                  border border-gray-700
                  focus:outline-none
                  focus:ring-1 focus:ring-gray-500
                "
              >
                {rooms
                  ?.filter(item => item.status !== "inactive")
                  ?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                ))}
              </select>

              {/* Dropdown Icon */}
              <ChevronDown
                size={16}
                className="absolute right-3 text-gray-400 pointer-events-none"
              />
            </div>
          </div>
        </div>

        {/* <button className=" bg-color6 text-black px-2.5 h-8 tab-max:h-10 rounded" onClick={()=>{setIsAddNewBookingTableModalOpen(true); setIsItemEdit(false)}}>
          Quick Table
        </button> */}
      </div>
      <QuickTableModal 
        isOpen={isAddNewBookingTableModalOpen}
        onClose={closeAddNewBookingTableModal}
      />
    </>
  );
}
